import { Injectable } from '@angular/core';
import { ModuleUserAccessLevel } from '../../constants-types';
import { ModuleUser, ModuleUserServer } from '../../core-data-model/ModuleUser';

@Injectable({ providedIn: 'root' })
export class ModuleUserTransformer {
    transformServerToClient(server: ModuleUserServer[]): ModuleUser[] {
        return server.map((user) => {
            let isCompanyAdmin = false;
            if (user.accessLevel === ModuleUserAccessLevel.CompanyAdmin) {
                // Mapping Company Admin as Admin and adding meta data to identify the same
                user.accessLevel = ModuleUserAccessLevel.Admin;
                isCompanyAdmin = true;
            }
            return {
                userId: user.userId,
                firstName: user.firstName,
                lastName: user.lastName,
                email: user.email,
                accessLevel: user.accessLevel,
                canUseVms: user.canSpendVMs,
                isCompanyAdmin: isCompanyAdmin
            };
        });
    }
}
